/**
 * Device preview — heal viewport + load mode (default desktop setelah heal).
 */
export default defineNuxtPlugin(() => {
  if (!import.meta.client) return;

  try {
    // Paksa semua meta viewport aman SEBELUM load mode
    document.querySelectorAll('meta[name="viewport"]').forEach((el) => {
      el.setAttribute('content', 'width=device-width, initial-scale=1');
    });
    document.documentElement.classList.remove(
      'jgi-device-hp',
      'jgi-device-tablet',
      'jgi-device-desktop'
    );
  } catch {
    /* ignore */
  }

  const { load, restoreSafeViewport } = useDevicePreview();
  load();
  restoreSafeViewport();
});
